var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2537_9927)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2537_9927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 43,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5208 18.7636C45.5208 19.2394 45.5027 19.7111 45.4669 20.178L50 29.6727H45.5208V40.1454H34.7708V48H15.0625V40.1454V34.0319C10.1811 30.6281 7 25.0578 7 18.7636C7 8.40077 15.6232 0 26.2604 0C36.8976 0 45.5208 8.40077 45.5208 18.7636Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2537_9927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4669 20.178L41.4786 19.8729L41.3971 20.9377L41.8572 21.9014L45.4669 20.178ZM50 29.6727V33.6727H56.3422L53.6097 27.9493L50 29.6727ZM45.5208 29.6727V25.6727H41.5208V29.6727H45.5208ZM45.5208 40.1454V44.1454H49.5208V40.1454H45.5208ZM34.7708 40.1454V36.1454H30.7708V40.1454H34.7708ZM34.7708 48V52H38.7708V48H34.7708ZM15.0625 48H11.0625V52H15.0625V48ZM15.0625 34.0319H19.0625V31.9447L17.3504 30.7508L15.0625 34.0319ZM49.4553 20.4831C49.4988 19.9148 49.5208 19.3414 49.5208 18.7636H41.5208C41.5208 19.1375 41.5066 19.5074 41.4786 19.8729L49.4553 20.4831ZM53.6097 27.9493L49.0766 18.4546L41.8572 21.9014L46.3903 31.3961L53.6097 27.9493ZM45.5208 33.6727H50V25.6727H45.5208V33.6727ZM49.5208 40.1454V29.6727H41.5208V40.1454H49.5208ZM34.7708 44.1454H45.5208V36.1454H34.7708V44.1454ZM30.7708 40.1454V48H38.7708V40.1454H30.7708ZM34.7708 44H15.0625V52H34.7708V44ZM19.0625 48V40.1454H11.0625V48H19.0625ZM19.0625 40.1454V34.0319H11.0625V40.1454H19.0625ZM3 18.7636C3 26.4478 6.8897 33.2094 12.7746 37.313L17.3504 30.7508C13.4725 28.0468 11 23.6677 11 18.7636H3ZM26.2604 -4C13.5132 -4 3 6.09374 3 18.7636H11C11 10.7078 17.7331 4 26.2604 4V-4ZM49.5208 18.7636C49.5208 6.09374 39.0076 -4 26.2604 -4V4C34.7877 4 41.5208 10.7078 41.5208 18.7636H49.5208Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2537_9927",
    x: -4,
    y: 0,
    width: 66,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2537_9927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2537_9927",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.f74258aab4112ebc90143fc56c92fe15.svg";
export { ForwardRef as ReactComponent };